<template>
    <div class="sensor-values-component">
        <b-row class="data">
            <b-col>
                <b-row>
                    <b-col class="group-header text-center" v-bind:class="{collapsed: collapsed}">
                        {{$t(deviceConfig.nameKey)}}
                        <b-icon-caret-down class="collapse-icon" scale="1.5" v-if="collapsed" @click="toggleStatus()" />
                        <b-icon-caret-up class="collapse-icon" scale="1.5" v-if="!collapsed" @click="toggleStatus()" />
                    </b-col>
                </b-row>
                <b-row class="bordered" v-show="!collapsed">
                    <b-col class="text-left data-container">
                        <div :key="value.path" v-for="value in valueList">
                            <span class="label" >{{$t(value.name)}}</span>{{extractValue(value)}}
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import JP from 'jsonpath';
import {SensorInfo, SensorInfoConfig, SensorValueType} from "../../Repository/Sensors/SensorsRepository";

@Component({
    props: {
        deviceConfig: { type: Object, required: true, },
        source: { type: Object, required: true, },
    },
})
class SensorValues extends Vue {
    collapsed: boolean = false;

    get valueList(): SensorInfoConfig[] {
        return this.getConfig().config.values;
    }

    getConfig(): SensorInfo {
        return this.$props.deviceConfig;
    }

    extractValue(config: SensorInfoConfig): any {
        const rawValue: any = JP.query(this.$props.source, config.path, 1);
        if (!rawValue.length) {
            return '--';
        }
        const mapDictionary = (value: any, dictionary: {name: string, value: any}[]): string => {
            const name = dictionary.find(q => q.value === value)?.name;
            return name ? this.$t(name).toString() : value;
        }

        switch (config.type) {
            case SensorValueType.DICTIONARY:
                return mapDictionary(rawValue[0], config.dictionary ?? []);
            case SensorValueType.RAW:
                return rawValue;
            default:
                throw new Error('Unknown sensor value type: ' + config.type);
        }
    }

    toggleStatus() {
        this.collapsed = !this.collapsed;
    }
}

export default SensorValues;
</script>

<style lang="scss" scoped>

.sensor-values-component {

    .bordered {
        border: 1px solid white;
    }

    .data {
        padding-top: 1em;

        .label {
            margin-right: 0.5em;
            font-weight: bolder;
        }

        .col {
            .text-center {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .group-header {
            background-color: gray;
            border: 1px solid white;
            border-bottom: none;
            position: relative;

            &.collapsed {
                border-bottom: 1px solid white;
            }

            .collapse-icon {
                position: absolute;
                right: 15px;
                cursor: pointer;
            }
        }

        .status-name {
            font-weight: bold;
            margin-right: 0.5em;
        }

        .data-container {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }


}

</style>
